import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {GetAttributeComponentParameters} from "#template/nodes/geometry-graph/attribute/get-attribute-component/geometry-get-attribute-component-node"
import {
    GeometryGetAttributeComponentNode,
    getAttributeComponentParametersSchema,
} from "#template/nodes/geometry-graph/attribute/get-attribute-component/geometry-get-attribute-component-node"

export type PointGeometryGetAttributeComponentParameters = GetAttributeComponentParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryGetAttributeComponentParameters> = {
    nodeClass: "PointGeometryGetAttributeComponent",
    validation: {
        parameters: getAttributeComponentParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryGetAttributeComponent
    extends GeometryGetAttributeComponentNode<0, PointGeometryAttributeLikeNode>
    implements PointGeometryAttributeLikeNode
{
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
